<div class="container mt-5">

    <foehn-page-counter></foehn-page-counter>

    <foehn-form>
        <div class="row">
            <div class="col-md-8">
                <h3> Situation actuelle </h3>
                <br>
                <foehn-select
                    [(model)]="form.careerApplicant.levelOfEducation"
                    [elementValue]="wholeValue"
                    [elements]="levelOfEducations"
                    [label]="'career-applicant.levelOfEducation.label' | fromDictionary"
                    elementLabel="valeur"
                    name="careerApplicant.levelOfEducation"
                    required="true"
                >
                </foehn-select>
                <foehn-select
                    [(model)]="form.careerApplicant.levelOfFrench"
                    [elementValue]="wholeValue"
                    [elements]="levelsOfFrench"
                    [label]="'career-applicant.levelOfFrench.label' | fromDictionary"
                    elementLabel="valeur"
                    name="careerApplicant.levelOfFrench"
                    required="true"
                >
                </foehn-select>
                <br>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <h3> Projet </h3>
                <br>
                <foehn-select
                    [(model)]="form.professionalProject.projectType"
                    [elementValue]="wholeValue"
                    [elements]="projectTypes"
                    [label]="'professional-project.projectType.label' | fromDictionary"
                    elementLabel="valeur"
                    name="professionalProject.projectType"
                    required="true"
                >
                </foehn-select>
                <foehn-input-text
                    [(model)]="form.professionalProject.intendedProfession"
                    [label]="'professional-project.intendedProfession.label' | fromDictionary"
                    name="professionalProject.intendedProfession"
                    [max]="3500"
                    required="true"
                >
                </foehn-input-text>

                <foehn-input-text
                    [(model)]="form.professionalProject.specialization"
                    [label]="'professional-project.specialization.label' | fromDictionary"
                    name="professionalProject.specialization"
                >
                </foehn-input-text>

                <foehn-input-textarea
                    [(model)]="form.professionalProject.comment"
                    [displayCharCount]="true"
                    [label]="'professional-project.comment.label' | fromDictionary"
                    [max]="3500"
                    name="professionalProject.comment"
                    required="true"
                ></foehn-input-textarea>

                <foehn-navigation
                    (onNext)="send()"
                    (onPrevious)="previous()"
                    id="navigation"
                ></foehn-navigation>
            </div>
        </div>
    </foehn-form>
</div>
